<!--
  Items that can be reordered by drag and drop.
  It has no specific representation
  The ordering button needs to be inserted manually with <orderable-item-button>
  The delete button needs to be managed manually

  Props:
  - group: all items with the same groups can be reordered with each other
  - index: the index of the item in the group
  - disabled: true to disable reordering
  - newItem: true for a new item, no difference with disabled
-->

<template>
  <div :class="['orderable-item', {
    'orderable-item--dragged': dragged,
    'orderable-item--drop-top': targeted === -1,
    'orderable-item--drop-bottom': targeted === 1,
  }]"
    @dragover="handleDragover"
    @dragleave="handleDragleave"
    @drop="handleDrop">
    <slot></slot>
  </div>
</template>

<script>
import $ from 'jquery'

// mimetype used
let TYPE = 'orderable-item/drag'
// a global object to know who's being dragged
let DRAGGED = { group: null, index: null }

export default {
  name: 'OrderableItem',
  props: {
    // identifies items that are in the same array
    group: String,
    // index number of this item
    index: Number,
    // disable delete and drag
    disabled: Boolean,
    // add submit button
    newItem: Boolean,
  },
  provide () {
    return {
      OrderableItem: this,
    }
  },
  data () {
    return {
      dragged: false,
      targeted: 0,
      DRAGGED: DRAGGED,
    }
  },
  watch: {
    'DRAGGED.group' (val) {
      if (val !== this.group) this.targeted = 0
    },
  },
  methods: {
    // sets dataTransfer to start draging
    handleDragstart (e) {
      if (this.disabled || this.newItem) return
      e.dataTransfer.setData(TYPE, 'true')
      e.dataTransfer.dropEffect = 'move'
      this.DRAGGED.group = this.group
      this.DRAGGED.index = this.index
      this.dragged = true
    },
    // empties DRAGGED
    handleDragend (e) {
      this.DRAGGED.group = null
      this.DRAGGED.index = null
      this.dragged = false
    },
    // stops showing it
    handleDragleave (e) {
      if (this.disabled || this.newItem) return
      if (!e.relatedTarget ||
        e.relatedTarget.parentNode.nodeType !== Node.ELEMENT_NODE ||
        $(e.relatedTarget).closest(this.$el).length) return
      this.targeted = 0
    },
    // acceptss the item and shows where the item will be droped
    handleDragover (e) {
      if (this.disabled || this.newItem) return
      if (DRAGGED.group !== this.group || DRAGGED.index === this.index) return
      let types = e.dataTransfer.types
      if (!types.find(v => v === TYPE)) return
      e.preventDefault()
      e.dataTransfer.dropEffect = 'move'
      this.targeted = Math.sign(this.index - DRAGGED.index)
    },
    // emits 'move' event to move the item
    handleDrop () {
      if (this.disabled || this.newItem) return
      this.targeted = 0
      this.$emit('move', DRAGGED.index, this.index)
    },
    // starts dragging effect
    handleMousedown () {
      if (this.disabled || this.newItem) return
      this.dragged = true
    },
    // stops dragging effect
    handleMouseup () {
      this.dragged = false
    },
  },
}
</script>

<style lang="scss">
  @import "../../element-variables.scss";

  /* little space between items */
  .orderable-item {
    box-shadow: 0 0 5px -5px $--border-color-base;
    transition-property: box-shadow, margin;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
  }
  /* for is item beng dragged */
  .orderable-item.orderable-item--dragged {
    opacity: 0.5;
  }
  /* shows insert before */
  .orderable-item.orderable-item--drop-top {
    margin-top: 16px;
    box-shadow: 0 -16px 5px -5px $--border-color-base;
  }
  /* shows insert after */
  .orderable-item.orderable-item--drop-bottom {
    margin-bottom: 16px;
    box-shadow: 0 16px 5px -5px $--border-color-base;
  }
</style>
